import { render, staticRenderFns } from "./VarModal.vue?vue&type=template&id=5bc50044&scoped=true"
import script from "./VarModal.vue?vue&type=script&lang=js"
export * from "./VarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc50044",
  null
  
)

export default component.exports